import { DocGenProduct, EventMetadata } from './events';

interface Window {
	pendo?: any;
}

// TODO - this functionality should move to piral appshell extension
export function pendoSendTrackEvent(event: string, metadata: EventMetadata = {}) {
	try {
		const pendo = (window as unknown as Window).pendo;
		if (!pendo?.track) {
			return;
		}
		const metadataWithProductName = {
			...metadata,
			product: DocGenProduct,
			type: event,
		};
		pendo.track(event, metadataWithProductName);
	} catch {}
}
